// トレッタAPI
const baseUrlForAuth = 'https://api.toletta-api.com/'
// トレッタ会員情報
const baseUrlForSignup = 'https://signup.tolettacat.com/'
// 数量ボタン
const quantityButtons = 'button.quantity__button, input.quantity__input' 
// 「shop payで購入」「別のお支払い方法で購入する」ボタン親要素
const shopifyPaymentButton = 'div.product-form__buttons > div.shopify-payment-button'
// 「shop payで購入」「別のお支払い方法で購入する」ボタン親要素の子要素
const shopifyPaymentButtonChild = shopifyPaymentButton + ' > shopify-accelerated-checkout'
// 「shop payで購入」ボタン要素
const shopPayButton = shopifyPaymentButton + ' shop-pay-wallet-button > gravity-button.accelerated-checkout-button'
// 「別のお支払い方法で購入する」ボタン要素
const anotherPaymentButton = shopifyPaymentButton + ' a.shopify-payment-button__more-options'
// エラータイプ
const ERROR_TYPE = Object.freeze({
  auth:        'auth-error',
  integration: 'integration-error',
  other:       'other-error'
})

/**
 * 初期設定を行う
 */
document.addEventListener('DOMContentLoaded', function() {
  const tlAuth = getTlAuth()
  if (tlAuth) {
    loggedIn(tlAuth)
  } else {
    notLoggedIn()
  }
  // トレッタ認証の入力項目(メールアドレス、パスワード)
  document.querySelectorAll('#tl-email, #tl-password').forEach((element) => {
    element.addEventListener('input', checkInputAuth)
  })
  // 「ログイン」ボタン
  document.querySelector('#tl-login').addEventListener('click', auth)
  // パスワード変更用入力項目(メールアドレス)
  document.querySelector('#tl-forgot-email').addEventListener('input', checkInputForgot)
  // 「パスワード変更」ボタン
  document.querySelector('#tl-forgot').addEventListener('click', change)
  // 「shop payで購入」「別のお支払い方法で購入する」ボタンにイベントを設定する
  setCheckoutEvent()
})

/**
 * 「shop payで購入」「別のお支払い方法で購入する」ボタンにクリックイベントを設定する
 */
function setCheckoutEvent() {
  // 描画タイミングによって設定出来ないことがあるため、取得出来なければリトライする
  // 「shop payで購入」ボタン
  const shopPayButtonIntervalId = setInterval(function(){
    const selectedShopPayButton = document.querySelector(shopPayButton)
    if (selectedShopPayButton) {
      selectedShopPayButton.addEventListener('click', checkLatestAuth, true)
      clearInterval(shopPayButtonIntervalId)
    }
  }, 500);
  // 「別のお支払い方法で購入する」ボタン
  const anotherPaymentButtonIntervalId = setInterval(function(){
    const selectedAnotherPaymentButton = document.querySelector(anotherPaymentButton)
    if (selectedAnotherPaymentButton) {
      selectedAnotherPaymentButton.addEventListener('click', checkLatestAuth, true)
      clearInterval(anotherPaymentButtonIntervalId)
    }
  }, 500);
}

/**
 * 最新の会員情報を取得する
 * @param {Event} event - イベント
 */
function checkLatestAuth(event) {
  const tlAuth = getTlAuth()
  if (tlAuth) {
    // 会員情報変更を取り込むため最新情報を取得する
    getUserInfo(tlAuth.token, event)
  } else {
    // トレッタの認証情報が破棄されている場合
    event.preventDefault()
    event.stopImmediatePropagation()
    notLoggedIn()
    displayModal(ERROR_TYPE.auth)
  }
}

/**
 * トレッタ認証の必須入力チェックを行う
 */
function checkInputAuth() {
  let isAllInput = true
  document.querySelectorAll('#tl-email, #tl-password').forEach((element) => {
    // 必須項目に入力が無い
    if (!element.value) isAllInput = false
  })
  // 必須項目の入力があれば押下可にする
  const loginButton = document.querySelector('#tl-login')
  if (isAllInput) {
    loginButton.setAttribute('href', 'javascript:void(0);')
  } else {
    loginButton.removeAttribute('href');
  }
}

/**
 * パスワード変更の必須入力チェックを行う
 */
function checkInputForgot() {
  const forgotButton = document.querySelector('#tl-forgot')
  // 必須項目の入力があれば押下可にする
  if (document.querySelector('#tl-forgot-email').value) {
    forgotButton.setAttribute('href', 'javascript:void(0);')
  } else {
    forgotButton.removeAttribute('href');
  }
}

/**
 * トレッタへの認証を行う
 */
function auth() {
  // メールアドレスとパスワードは必須
  const username = document.querySelector('#tl-email').value
  const password = document.querySelector('#tl-password').value
  if (!username || !password) return

  // 認証処理が終わるまで「ログイン」ボタン、「パスワード忘れ」リンクは非活性
  document.querySelectorAll('#tl-login, #tl-resetpassword').forEach((element) => element.setAttribute('disabled', true))

  const xhr = new XMLHttpRequest()
  xhr.open('POST', baseUrlForAuth + 'api/v2/apl/auth/login')
  setRequestHesder(xhr)
  xhr.onload = () => {
    if (isRequestOk(xhr)) {
      getUserInfo(JSON.parse(xhr.response).token)
    } else {
      // 認証処理が失敗した場合は「ログイン」ボタン、「パスワード忘れ」リンクは活性
      document.querySelectorAll('#tl-login, #tl-resetpassword').forEach((element) => element.removeAttribute('disabled'))
      displayModal(ERROR_TYPE.auth)
    }
  }
  const body = JSON.stringify({
    username,
    password,
  })
  xhr.send(body)
}

/**
 * トレッタユーザ情報取得
 * @param {string} token - トークン
 * @param {boolean} isCheckout - 購入手続きかの判定フラグ(true:購入手続き / false:購入手続き以外)
 */
function getUserInfo(token, event) {
  const xhr = new XMLHttpRequest()
  xhr.open('GET', baseUrlForAuth + 'api/v2/apl/user/me', false)
  setRequestHesder(xhr, token)
  xhr.onload = () => {
    if (isRequestOk(xhr)) {
      const response = JSON.parse(xhr.response)
      const integration_member_code = response.integration_member_code
      if (!integration_member_code) {
        // 支援コードが登録されていない場合
        if (event) {
          event.preventDefault()
          event.stopImmediatePropagation()
        }
        // 認証処理が失敗した場合は「ログイン」ボタン、「パスワード忘れ」リンクは活性
        document.querySelectorAll('#tl-login, #tl-resetpassword').forEach((element) => element.removeAttribute('disabled'))
        displayModal(ERROR_TYPE.integration)
        document.querySelector('#tl-integration').setAttribute('href', encodeURI(baseUrlForSignup + 'change?prm=' + token))
      } else {
        const tlAuth = {
          family_id: response.family_id,
          integration_member_code,
          token
        }
        putTlAuth(tlAuth)
        loggedIn(tlAuth)
      }
    } else {
      if (event) {
        event.preventDefault()
        event.stopImmediatePropagation()
      }
      // 認証処理が失敗した場合は「ログイン」ボタン、「パスワード忘れ」リンクは活性
      document.querySelectorAll('#tl-login, #tl-resetpassword').forEach((element) => element.removeAttribute('disabled'))
      displayModal(ERROR_TYPE.other)
    }
  }
  xhr.send()
}

/**
 * パスワード変更を行う
 */
function change() {
  // メールアドレスは必須
  const username = document.querySelector('#tl-forgot-email').value
  if (!username) return

  const xhr = new XMLHttpRequest()
  xhr.open('POST', baseUrlForAuth + 'api/v2/apl/user/forget')
  setRequestHesder(xhr)
  xhr.onload = () => {
    if (isRequestOk(xhr)) {
      document.querySelector('#tl-forgot-email-message').innerText = 'メールアドレス宛に新しいパスワードを送信しました。'
    } else {
      modalBg.removeChild(resetPasswordBox);
      displayModal(ERROR_TYPE.other)
    }
  }
  const body = JSON.stringify({
    'email': username
  })
  xhr.send(body)
}

/**
 * リクエスト結果チェックを行う
 * @param {XMLHttpRequest} xhr - XMLHttpRequest
 * @return {boolean} - true:チェックOK / false:チェックNG
 */
function isRequestOk(xhr) {
  return xhr.readyState === 4 && xhr.status === 200
}

/**
 * 認証済みの設定を行う
 * @param {object} tlAuth - 認証情報
 */
function loggedIn(tlAuth) {
  document.querySelector('#tl-not-logged-in').style.display = 'none'
  document.querySelector('#tl-logged-in').style.display = 'block'
  document.querySelector('#tl-modification').setAttribute('href', encodeURI(baseUrlForSignup + 'change?prm=' + getTlAuth().token))
  // トレッタ認証の入力項目(メールアドレス、パスワード)はクリアする
  document.querySelectorAll('#tl-email, #tl-password').forEach((element) => {
    element.value = ''
  })
  document.querySelector('#familyid').value = tlAuth.family_id
  document.querySelector('#mzdao').value = tlAuth.integration_member_code
  // 「shop payで購入」「別のお支払い方法で購入する」ボタンのスタイル設定を行う
  setShopifyButtonsStyle(true)
  // 数量ボタン
  document.querySelectorAll(quantityButtons).forEach((element) => {
    element.style.cursor = null
    element.removeAttribute('disabled')
  })
}

/**
 * 未認証の設定を行う
 */
function notLoggedIn() {
  document.querySelector('#tl-not-logged-in').style.display = 'block'
  document.querySelector('#tl-logged-in').style.display = 'none'
  document.querySelector('#tl-register').setAttribute('href', baseUrlForSignup)
  // 「shop payで購入」「別のお支払い方法で購入する」ボタンのスタイル設定を行う
  setShopifyButtonsStyle(false)
  // 数量ボタン
  document.querySelectorAll(quantityButtons).forEach((element) => {
    element.style.cursor = 'not-allowed'
    element.setAttribute('disabled', true)
  })
}

/**
 * 「shop payで購入」「別のお支払い方法で購入する」ボタン親子要素のスタイル設定を行う
 * @param {boolean} isLoggedIn - 認証状態(true: 認証済み / false:未認証)
 */
function setShopifyButtonsStyle(isLoggedIn) {
  // カーソルの設定
  const selectedShopifyPaymentButton = document.querySelector(shopifyPaymentButton)
  if (selectedShopifyPaymentButton) {
    setShopifyPaymentButtonStyle(selectedShopifyPaymentButton, isLoggedIn)
  } else {
    // 描画タイミングによって取得出来ないリトライする
    const shopifyPaymentButtonIntervalId = setInterval(function(){
      const selectedShopifyPaymentButton = document.querySelector(shopifyPaymentButton)
      // 描画されていたらstyleを設定してリトライ終了
      if (selectedShopifyPaymentButton) {
        setShopifyPaymentButtonStyle(selectedShopifyPaymentButton, isLoggedIn)
        clearInterval(shopifyPaymentButtonIntervalId)
      }
    }, 500);
  }
  // イベントの設定
  const selectedShopifyPaymentButtonChild = document.querySelector(shopifyPaymentButtonChild)
  if (selectedShopifyPaymentButtonChild) {
    setShopifyPaymentButtonChildStyle(selectedShopifyPaymentButtonChild, isLoggedIn)
  } else {
    // 描画タイミングによって取得出来ないリトライする
    const shopifyPaymentButtonChildIntervalId = setInterval(function(){
      const selectedShopifyPaymentButtonChild = document.querySelector(shopifyPaymentButtonChild)
      // 描画されていたらstyleを設定してリトライ終了
      if (selectedShopifyPaymentButtonChild) {
        setShopifyPaymentButtonChildStyle(selectedShopifyPaymentButtonChild, isLoggedIn)
        clearInterval(shopifyPaymentButtonChildIntervalId)
      }
    }, 500);
  }
}

/**
 * 「shop payで購入」「別のお支払い方法で購入する」ボタン親要素のスタイル設定を行う
 * @param {object} selectedShopifyPaymentButton - 「shop payで購入」「別のお支払い方法で購入する」ボタン親要素のElementオブジェクト
 * @param {boolean} isLoggedIn - 認証状態(true: 認証済み / false:未認証)
 */
function setShopifyPaymentButtonStyle(selectedShopifyPaymentButton, isLoggedIn) {
  if (isLoggedIn) {
    selectedShopifyPaymentButton.style.cursor = null
    selectedShopifyPaymentButton.style.opacity = '1'
  } else {
    selectedShopifyPaymentButton.style.cursor = 'not-allowed'
    selectedShopifyPaymentButton.style.opacity = '.5'
  }
}

/**
 * 「shop payで購入」「別のお支払い方法で購入する」ボタン子要素のスタイル設定を行う
 * @param {object} ShopifyPaymentButtonChild - 「shop payで購入」「別のお支払い方法で購入する」ボタン子要素のElementオブジェクト
 * @param {boolean} isLoggedIn - 認証状態(true: 認証済み / false:未認証)
 */
function setShopifyPaymentButtonChildStyle(selectedShopifyPaymentButtonChild, isLoggedIn) {
  if (isLoggedIn) {
    selectedShopifyPaymentButtonChild.style.setProperty('pointer-events', 'auto')
  } else {
    selectedShopifyPaymentButtonChild.style.setProperty('pointer-events', 'none')
  }
}

/**
 * リクエストヘッダの設定を行う
 * @param {XMLHttpRequest} xhr - XMLHttpRequest
 * @param {string} token - トークン
 */
function setRequestHesder(xhr, token) {
  xhr.setRequestHeader('Content-Type', 'application/json')
  xhr.setRequestHeader('Cache-Control', 'no-cache')
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
  if (token) {
    xhr.setRequestHeader('Authorization', `Bearer ${token}`)
  }
}

/**
 * 認証情報の保存を行う
 * @param {object} tlAuth - 認証情報
 */
function putTlAuth(tlAuth) {
  sessionStorage.setItem('tl-auth', btoa(tlAuth.family_id) + ':' + btoa(tlAuth.integration_member_code) + ':' + tlAuth.token)
}

/**
 * 認証情報の返却を行う
 * @return {object} - 認証情報(保存されていなければnull)
 */
function getTlAuth() {
  const item = sessionStorage.getItem('tl-auth')
  if (item) {
    const items = item.split(':')
    return {
      family_id: atob(items[0]),
      integration_member_code: atob(items[1]),
      token: items[2]
    }
  } else {
    return
  }
}
